export default __webpack_public_path__ + "static/media/evening.b91ae52d.svg";